<template>
  <vxe-grid
    ref="xTable"
    v-on="$listeners"
    v-bind="$attrs"
    v-loading="loading"
    class="gj-lrz-table gj-base-table"
    :columns="tableColumn"
    height="auto"
    border="inner"
    auto-resize
    row-id="rowId"
    :loading="false"
    :scroll-y="{mode: 'wheel',oSize:20}"
    :sort-config="{trigger: 'cell', defaultSort: handleDefaultSort, remote: true}"
    :data="tableData">
    <!-- 通用图片组件 -->
    <template v-slot:image="{row}">
      <gj-image :src="row[imageKey]"></gj-image>
    </template>
    <!-- 传递插槽  -->
    <template v-for="item in slotArr" v-slot:[item]="props">
      <slot :name="item" v-bind="props" />
    </template>
    <!-- 无数据页面展示 -->
    <template #empty>
      <gj-empty text="暂无数据"></gj-empty>
    </template>
    <!-- 分页器 -->
    <template #pager>
      <div v-show="pagerConfig.total>0" class="gj-table-pagination">
        <el-pagination @size-change="pageChange"
          @current-change="pageChange('page')"
          :current-page.sync="pagerConfig.currentPage"
          :page-sizes="pageSizes"
          :page-size.sync="pagerConfig.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagerConfig.total"
          background
          :pager-count="5">
        </el-pagination>
      </div>
    </template>
  </vxe-grid>
</template>

<script>
import { CACHE_PAGINATION_PAGESIZE } from '@/utils/const'
import _ from 'lodash'
export default {
  props: {
    /** 表格数据 */
    list: {
      type: Array,
      default: () => [],
      require: true
    },
    /**
     * 配置动态列的数组  配置文档查看官方文档
     * @see {@link https://xuliangzhan_admin.gitee.io/vxe-table/#/grid/api columns}
     */
    columns:{
      type:Array,
      default:()=>[],
      require:true
    },
    /** 页面加载的loading */
    loading: {
      type: Boolean,
      default: false
    },
    /** 分页器相关配置 */
    pagerConfig: {
      type: Object,
      require: true,
      default: () => {
        return {
          currentPage: 1,
          pageSize: 20,
          total: 0
        }
      }
    },
    /** 分页数组配置 */
    pageSizes: {
      type: Array,
      default: () => {
        return [20, 50, 100, 200, 500]
      }
    },
    /** 排序配置 */
    defaultSort: {
      type: Object,
      default: null
    },
    /** 是否需要转 */
    isFormat:{
      type:Boolean,
      default:false
    },
  },
  data () {
    return {
      tableData: [],
      tableColumn:[], // 动态列的配置数据
      imageKey:''
    }
  },
  watch: {
    list: {
      handler (newVal, oldVal) {
        this.handleData(newVal)
      },
      immediate: true
    },
    columns : {
      handler(newVal,oldVal){
        this.handleColumns(_.cloneDeep(newVal))
        this.handleSlots(this.tableColumn)
      },
      immediate:true
    },
  },
  methods: {
    /** 监听数据 添加数据标识 */
    handleData (data) {
      this.tableData = data.map((v,i)=>{
        v.rowId = `rId_${i+30}`
        return v
      })
    },
     /**
     * 遍历出 需要在vxe-grid注册的插槽  传递插槽
     * @param { arrry } columns -表格列的配置的数据
     * @returns {Arrry} 返回插槽数据列表
     */
    handleSlots(columns){
      const slots = columns.filter(v=>v.slots).map(v=>v.slots)
      // 组件已经封装好的插槽 防止重复注册
      let alreadySlots = ['check','headerCheck']
      // 兼容处理
      if(this.isFormat){
        alreadySlots.push('image')
      }
      this.slotArr = [...slots.map(v=>v.default).filter(v=>v),...slots.map(v=>v.header).filter(v=>v)].filter(v=>!alreadySlots.includes(v))
    },
    /** 对column做的一些判断 */
    handleColumns(columns){
      // 原有脏columns 进行格式化处理
      if(this.isFormat){
        this.formatColumns(columns)
      }
      // 处理默认值问题
      columns.map(v=>{
        if(!v.formatter && !v.slots){
          v.formatter = this.handleDefaultShow()
        }
        return v
      })
      this.tableColumn = columns
    },
    /** 格式化columns 数据 */
    formatColumns(columns){
      columns.map(v=>{
        v.title = v.header
        if(v.field.includes('slot')){
          v.slots = {
            default: v.field.split('slot:')[1]
          }
          v.field = v.field.split('slot:')[1]
        }
        // 图片
        if(v.field.includes('picture')){
          v.slots = {
            default:'image'
          }
          this.imageKey = v.field.split('picture:')[1]
          v.field = this.imageKey
        }
        // 枚举
        if(v.field.includes('option')){
          v.options = typeof v.options === 'function' ? v.options() : v.options
          v.formatter = this.handleEnum(v.options)
          v.field = v.field.split('option:')[1]
        }
        return v
      })
    },
    /**
     * 处理枚举 柯里化
     * @param {Array} options '枚举的项列表'
    */
    handleEnum(options){
      return function({cellValue}){
        if(!cellValue) return '-'
        return options.find(v=>v.id === cellValue).text
      }
    },
    /** 处理默认值 */
    handleDefaultShow(){
      return function({cellValue}){
        let showValue = '-'
        if(cellValue!==undefined && cellValue !== null){
          showValue = cellValue
        }
        return showValue
      }
    },
    /** 分页 */
    pageChange (page) {
      this.$cache.setCache(CACHE_PAGINATION_PAGESIZE.call(this), { pageSize: this.pagerConfig.pageSize })
      this.$emit('page-change', page)
      this.$emit('selection-change', []);
    },
    /**
     * 处理排序
     */
    handleDefaultSort () {
      if (this.defaultSort) {
        return {
          field: this.defaultSort.prop,
          order: (this.defaultSort.order || 'descending').replace('ending', '')
        }
      }
      return null
    },
  }
}
</script>

<style lang="scss">
  .gj-base-table{
    .vxe-table--render-default .vxe-header--column.col--ellipsis:not(.col--actived) > .vxe-cell, .vxe-table--render-default .vxe-body--column.col--ellipsis:not(.col--actived) > .vxe-cell, .vxe-table--render-default .vxe-footer--column.col--ellipsis:not(.col--actived) > .vxe-cell, .vxe-checkbox .vxe-checkbox--label, .vxe-radio .vxe-radio--label, .vxe-radio-button .vxe-radio--label{
      overflow: unset;
      white-space: unset;
      text-overflow: unset;
    }
  }
</style>
<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
  /deep/ .col--last{
    .vxe-cell{
      padding-left: 16px;
    }
  }
  /deep/ .vxe-table--footer-wrapper{
    color: #333;
  }
  /deep/.gj-help--icon{
    .gj-icon{
      font-size: 13px;
      color: #666;
    }
  }
  /deep/ .vxe-table--border-line{
    border: 1px solid #d8dadd !important;
  }
  ::v-deep .vxe-table  .vxe-header--row {
    height: 40px !important;
    background: $gj-tableHeader-color;
  }
  ::v-deep .vxe-table  .vxe-footer--row{
    background: $gj-tableHeader-color;
  }
  /deep/ .col--right{
    .vxe-cell{
      justify-content: flex-end;
    }
  }

  /deep/ .vxe-table--render-default .vxe-table--fixed-left-wrapper.scrolling--middle {
    box-shadow: 4px 0px 6px -2px rgba($color: #000000, $alpha: 0.12);
  }
  /deep/ .vxe-table--render-default .vxe-table--fixed-right-wrapper.scrolling--middle{
    box-shadow: -4px 0 6px -2px rgba($color: #000000, $alpha: 0.12);
  }
  /deep/ .vxe-table--footer{
    height: 40px;
  }
  /deep/ .vxe-table--render-default .vxe-table--footer-wrapper{
    background-color: #e8eaec;
  }
  /* 字体大小 */
  /deep/ .vxe-table.size--small {
    font-size: 12px;
  }
 .el-pagination{
    font-weight: normal;
 }
 /deep/ .vxe-table--render-default .vxe-body--row.row--hover {
   background-color: $gj-hover-color;
}

</style>
